import { FormControlLabel } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import React, { useState } from 'react'
import * as styles from './checkbox.module.less'

interface Props {
  label: string
  onChange: (state: boolean) => void
  initialState?: boolean
  indeterminate?: boolean
  disabled?: boolean
  props?: any
}

const CheckboxLabel: React.FC<Props> = ({
  label,
  onChange,
  initialState = false,
  disabled = false,
  indeterminate,
  ...props
}: Props) => {
  const [state, setState] = useState(initialState)

  const handleChange = () => {
    onChange && onChange(!state)
    setState(!state)
  }

  return (
    <FormControlLabel
      classes={{ root: styles.checkboxLabel, label: styles.checkboxLabel }}
      className={styles.checkboxLabel}
      control={
        <Checkbox
          classes={{
            root: styles.root,
            colorSecondary: disabled ? styles.disabled : styles.colorSecondary
          }}
          checked={state}
          onChange={handleChange}
          indeterminate={indeterminate}
          disabled={disabled}
          {...props}
        />
      }
      label={label}
    />
  )
}

export default CheckboxLabel
